import React from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import RedeemRoundedIcon from "@mui/icons-material/RedeemRounded";
import FavoriteRoundedIcon from "@mui/icons-material/FavoriteRounded";
import { GARANZIE_PREZZI } from "../../constants";

const StepDatiPersonali = ({
  formData,
  errors,
  vitaGaranzie,
  premioTotale,
  onInputChange,
  onBack,
  onSubmit,
  onReset,
}) => {
  return (
    <Box sx={{ maxWidth: 900, mx: "auto" }}>
      <Stack direction="row" spacing={2} alignItems="center" mb={4}>
        <Avatar sx={{ bgcolor: "#13b86d", width: 48, height: 48 }}>
          <RedeemRoundedIcon />
        </Avatar>
        <Box>
          <Typography variant="h5" fontWeight={700}>
            Dati Personali
          </Typography>
        </Box>
      </Stack>

      <Card
        sx={{
          mb: 3,
          borderRadius: 3,
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        }}
      >
        <CardContent sx={{ p: 4 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Nome"
                placeholder="Il tuo nome"
                value={formData.nome}
                onChange={onInputChange("nome")}
                required
                error={errors.nome}
                helperText={errors.nome ? "Campo obbligatorio" : ""}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Cognome"
                placeholder="Il tuo cognome"
                value={formData.cognome}
                onChange={onInputChange("cognome")}
                required
                error={errors.cognome}
                helperText={errors.cognome ? "Campo obbligatorio" : ""}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Email"
                type="email"
                placeholder="la.tua@email.com"
                value={formData.email}
                onChange={onInputChange("email")}
                required
                error={errors.email}
                helperText={errors.email ? "Campo obbligatorio" : ""}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Telefono"
                placeholder="+39 123 456 7890"
                value={formData.telefono}
                onChange={onInputChange("telefono")}
                required
                error={errors.telefono}
                helperText={errors.telefono ? "Campo obbligatorio" : ""}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Codice Fiscale"
                placeholder="RSSMRA80A01H501Z"
                value={formData.codiceFiscale}
                onChange={onInputChange("codiceFiscale")}
                variant="outlined"
                inputProps={{ style: { textTransform: "uppercase" } }}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Riepilogo Coperture */}
      <Card
        sx={{
          mb: 3,
          borderRadius: 3,
          bgcolor: (theme) =>
            theme.palette.mode === "dark"
              ? "rgba(19, 184, 109, 0.15)"
              : "rgba(19, 184, 109, 0.08)",
          border: "1px solid #13b86d",
        }}
      >
        <CardContent sx={{ p: 3 }}>
          <Typography
            variant="h6"
            fontWeight={700}
            mb={2}
            sx={{ color: "#13b86d" }}
          >
            Riepilogo Coperture
          </Typography>

          {vitaGaranzie.decesso.enabled && (
            <Box display="flex" justifyContent="space-between" mb={1}>
              <Typography variant="body2">
                Decesso ({vitaGaranzie.decesso.durata} anni -{" "}
                {vitaGaranzie.decesso.capitale.toLocaleString()}€)
              </Typography>
              <Typography variant="body2" fontWeight={600}>
                {GARANZIE_PREZZI.decesso}.00€
              </Typography>
            </Box>
          )}
          {vitaGaranzie.invalidita.enabled && (
            <Box display="flex" justifyContent="space-between" mb={1}>
              <Typography variant="body2">
                Invalidità Totale Permanente ({vitaGaranzie.invalidita.durata}{" "}
                anni - {vitaGaranzie.invalidita.capitale.toLocaleString()}€)
              </Typography>
              <Typography variant="body2" fontWeight={600}>
                {GARANZIE_PREZZI.invalidita}.00€
              </Typography>
            </Box>
          )}
          {vitaGaranzie.malattiaGrave.enabled && (
            <Box display="flex" justifyContent="space-between" mb={1}>
              <Typography variant="body2">
                Malattia Grave ({vitaGaranzie.malattiaGrave.durata} anni -{" "}
                {vitaGaranzie.malattiaGrave.capitale.toLocaleString()}€)
              </Typography>
              <Typography variant="body2" fontWeight={600}>
                {GARANZIE_PREZZI.malattiaGrave}.00€
              </Typography>
            </Box>
          )}
          {vitaGaranzie.inabilita.enabled && (
            <Box display="flex" justifyContent="space-between" mb={1}>
              <Typography variant="body2">
                Inabilità Totale Temporanea ({vitaGaranzie.inabilita.durata}{" "}
                anni - {vitaGaranzie.inabilita.capitale.toLocaleString()}€)
              </Typography>
              <Typography variant="body2" fontWeight={600}>
                {GARANZIE_PREZZI.inabilita}.00€
              </Typography>
            </Box>
          )}

          <Divider sx={{ my: 2 }} />

          <Box display="flex" justifyContent="space-between">
            <Typography variant="h6" fontWeight={700}>
              Totale Annuo
            </Typography>
            <Typography variant="h6" fontWeight={700} sx={{ color: "#13b86d" }}>
              {premioTotale}.00€
            </Typography>
          </Box>
        </CardContent>
      </Card>

      {/* Bottone Checkout */}
      <Stack direction="row" spacing={2}>
        <Button
          variant="outlined"
          size="large"
          onClick={onBack}
          sx={{
            flex: 1,
            borderColor: "#13b86d",
            color: "#13b86d",
            "&:hover": {
              borderColor: "#10ac7d",
              bgcolor: "rgba(19, 184, 109, 0.08)",
            },
            py: 1.5,
            fontSize: "1.1rem",
          }}
        >
          Indietro
        </Button>
        <Button
          variant="outlined"
          size="large"
          onClick={onReset}
          sx={{
            flex: 1,
            py: 1.5,
            fontSize: "1.1rem",
          }}
        >
          Reset
        </Button>
        <Button
          variant="contained"
          size="large"
          onClick={onSubmit}
          startIcon={<FavoriteRoundedIcon />}
          sx={{
            flex: 2,
            bgcolor: "#13b86d",
            "&:hover": { bgcolor: "#10ac7d" },
            py: 1.5,
            fontSize: "1.1rem",
          }}
        >
          Procedi al Checkout - {premioTotale}.00€
        </Button>
      </Stack>
    </Box>
  );
};

export default StepDatiPersonali;
